const VideoModalHandler = () => {
  const videoBtn = document.querySelectorAll(".open-modal");

  if (videoBtn.length > 0) {
    videoBtn.forEach((el) => {
      if (el.classList.contains("hot")) {
        return;
      }

      el.classList.add("hot");
      el.addEventListener("click", function (e) {
        document.body.classList.add("showing-modal");

        const modalId = el.getAttribute("data-modal-id");
        const modal = document.querySelector(`#${modalId}`);

        if (modal) {
          modal.classList.add("active");

          const video = modal.querySelector("video");
          if (video) {
            video.play();
          }
        }
      });
    });
  }
};

export default VideoModalHandler;
